export const allPostTagsVariables = { page: 1, pageSize: 100 };
export const allPostCategoriesVariables = { page: 1, pageSize: 100 };
export const allNewsVariables = { page: 1, pageSize: 100 };
